// extracted by mini-css-extract-plugin
export default {"panel":"style_panel__rHB6g","panel__action":"style_panel__action__K3LN7","panel__table":"style_panel__table__davnU","panel__header":"style_panel__header__HXdvN"};